"use strict";
angular.module("eventAnalysisModule", [
    "eventAnalysisRouterModule",
    "eventAnalysisMainModule",
    "eventAnalysisDetailModule",
    "newListModule",
    "eventAnalysisServiceModule",
    "navPositionModule",//局部导航
    "myTagsInputModule",//局部标签输入组件
    "picCarouselModule",//手动图片轮播
    "carouselModule",//自动图片轮播
    "eventAnalysisEchartModule",
    "imgAdapaModule",
]).
controller("eventAnalysisCtrl", [function() {

}]);